import { IExternalCourseParticipant } from 'models/externalCourseParticipant.model'
import { sortTableEnum } from 'enum/sortTable.enum'
import api from '../..'
import { applyFilters } from '../../../helpers/filterData.helper'

export interface GetListResponse {
  data: IExternalCourseParticipant[]
  total: number
  perPage: number
}

export interface ExternalCourseParticipantsListSort {
  field?: string
  order?: sortTableEnum
}

export interface ExternalCourseParticipantsListParams {
  page?: number
  searchText?: string
  sort?: ExternalCourseParticipantsListSort
  usersFilter?: any
  perPage?: number
  fastFilters?: number
}

const externalCourseParticipantsList = (
  externalCourseId: string | number,
  params?: ExternalCourseParticipantsListParams
) => {
  const {
    page = 1,
    searchText,
    usersFilter,
    sort,
    perPage = 50,
  } = {
    ...params,
  }
  let q = { s: '', g: [{}] } as any
  const { field, order } = { ...sort }
  q['s'] = (field && order && [`${field} ${sortTableEnum[order]}`]) || [
    'created_at desc',
  ]
  q['m'] = 'and'
  q['user_full_name_or_user_identifier_or_user_position_cont'] = searchText
  q = { ...q, g: applyFilters(usersFilter) }

  return api
    .post(
      `administration/external_courses/${externalCourseId}/external_course_participant/search`,
      { page, perPage, q }
    )
    .then<GetListResponse>(({ data, headers }) => {
      return {
        data: data.data.map(({ attributes }) => attributes),
        total: +headers['total'],
        perPage: +headers['per-page'],
      }
    })
}

export default externalCourseParticipantsList
